export type TabEntityType = 'tab' | 'content';

export function assignIdToAttribute(targetElement: HTMLElement, attribute: string, id: string): void {
  // already configured/set attributes have priority over automatically generated ones!
  targetElement.setAttribute(attribute, targetElement.getAttribute(attribute) || id);
}

export function constructId(namespace: string, name: string, type: TabEntityType): string {
  return `${namespace}__${name}__${type}`;
}

export function connectTabAndContent(namespace: string, tabEl: HTMLWbTabElement, tabContentEl: HTMLWbTabContentElement): void {
  assignIdToAttribute(tabEl, 'id', constructId(namespace, tabEl.name, 'tab'));
  assignIdToAttribute(tabEl, 'aria-controls', constructId(namespace, tabEl.name, 'content'));
  assignIdToAttribute(tabContentEl, 'id', constructId(namespace, tabContentEl.name, 'content'));
  assignIdToAttribute(tabContentEl, 'aria-labelledby', constructId(namespace, tabContentEl.name, 'tab'));
}
